
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 324.989 324.989"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M315.256 9.832l-.083-.083C308.762 3.462 300.265 0 291.248 0c-9.141 0-17.72 3.543-24.157 9.976a5.576 5.576 0 00-.198.208l-96.957 106.63-30.805-30.804c-4.355-4.271-10.125-6.622-16.245-6.622-6.207 0-12.033 2.408-16.407 6.781l-50.782 50.765a6 6 0 000 8.486l2.476 2.476-56.409 56.39a5.996 5.996 0 00-.001 8.485l44.184 44.184.001.002.002.001 66.273 66.274a5.979 5.979 0 004.242 1.758c1.535 0 3.07-.586 4.242-1.757l56.409-56.391 2.466 2.466a6 6 0 008.486 0l50.766-50.783c8.959-8.958 9.029-23.607.117-32.694l-30.762-30.763 106.63-96.957c.071-.064.14-.13.207-.198 13.188-13.193 13.29-34.762.23-48.081zm-198.79 300.673l-13.602-13.602 23.403-23.394a6 6 0 00-8.484-8.486l-23.404 23.395-13.608-13.608 23.212-23.208a6 6 0 00-8.484-8.486l-23.213 23.209-13.609-13.609 23.027-23.019a6 6 0 00-8.484-8.486l-23.028 23.02-13.608-13.608 22.649-22.642a6 6 0 00-8.484-8.486l-22.65 22.643-13.606-13.606 52.163-52.146L168.568 258.42l-52.102 52.085zM230.349 210.04l-46.524 46.539-115.4-115.401 46.538-46.523a11.124 11.124 0 017.923-3.267c2.96 0 5.746 1.133 7.803 3.148l35.211 35.211 29.355 29.357a.055.055 0 00.008.006l35.162 35.164c4.283 4.368 4.25 11.44-.076 15.766zm76.286-160.706l-106.94 97.238-21.264-21.264 97.238-106.939C279.83 14.261 285.357 12 291.248 12c5.836 0 11.331 2.229 15.48 6.276 8.403 8.613 8.354 22.503-.093 31.058z"}})])
          )
        }
      }
    